/**
 * Video Editor request validation (PRD-style: the API never trusts what the
 * frontend sends; every dispatch route runs the body through these schemas).
 */
import { z } from 'zod';
import { VIDEO_EDITOR_OPERATIONS } from '../types/video-editor.js';
const OPERATION_IDS = VIDEO_EDITOR_OPERATIONS.map((op) => op.id);
/**
 * Dispatch a new video-editor job.
 *
 * `values` is the typed input map from the operation's schema. We accept it
 * as an arbitrary record here — the dispatch service does operation-specific
 * validation against the catalog schema before spawning ffmpeg.
 */
export const VideoEditorDispatchRequestSchema = z.object({
    operationId: z.enum(OPERATION_IDS),
    values: z.record(z.string(), z.unknown()),
    inputStagedPaths: z
        .array(z.string().min(1).max(2_048))
        .min(1, 'At least one staged input is required')
        .max(16, 'Too many inputs'),
});
/**
 * Grant body — same shape as visuals/template-fill grants.
 */
export const GrantVideoEditorBodySchema = z.object({
    userId: z.string().uuid(),
});
/**
 * Patch the Video Editor admin settings — Edits folder, Uploads folder, or
 * both. Either field can be `null` to clear it.
 */
export const PatchVideoEditorConfigRequestSchema = z
    .object({
    driveFolderInput: z
        .union([z.string().trim().max(2_048), z.null()])
        .optional(),
    uploadsFolderInput: z
        .union([z.string().trim().max(2_048), z.null()])
        .optional(),
})
    .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one field must be provided',
});
//# sourceMappingURL=video-editor.schema.js.map